import React from "react";
import { Typography, Paper, useTheme } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function DeploymentsPerCompanyChart({ data }) {
  const theme = useTheme();
  return (
    <Paper
      style={{ backgroundColor: theme.palette.success.main }}
      elevation={3}
      sx={{ padding: 2 }}
    >
      <Typography color={theme.palette.success.text} variant="h6" gutterBottom>
        Deployments per Company
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="deployments" fill="#FF8300" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}

export default DeploymentsPerCompanyChart;
